














import Vue from 'vue';
import purchaseBox from './purchaseBox.vue';
import adBanner from '@/components/common/banner/adBanner.vue';
export default Vue.extend({
    components: {
        purchaseBox,
        adBanner
    },
    data() {
        return {
            purchaselist: [],
            title: '',
            content: '',
            adPage: 'purchase',
            adType: ''
        };
    },
    created() {
        this.pager();
    },
    methods: {
        pager() {
            if (this.$route.name === 'purchase') {
                window.FRSToolV3.getConfig({ page: 'purchase', type: 'purchaseMenu' }).then((res: any) => {
                    this.purchaselist = res.result;
                    this.title = '選購基金';
                    this.content = '請根據下方選項說明，選擇挑選商品的方式。';
                    this.adType = 'purchaseBanner';
                });
            } else if (this.$route.name === 'purchase_top20') {
                window.FRSToolV3.getConfig({ page: 'purchase', type: 'purchaseTop20' }).then((res: any) => {
                    this.purchaselist = res.result;
                    this.title = '熱門商品';
                    this.content = '近三個月基富通客戶熱搜排行榜。';
                    this.adType = 'purchaseTop20Banner';
                });
            } else if (this.$route.name === 'purchase_smartChoice') {
                window.FRSToolV3.getConfig({ page: 'purchase', type: 'smartChoice' }).then((res: any) => {
                    this.purchaselist = res.result;
                    this.title = '聰明選基金';
                    this.content = '根據投資需求，透過單筆或定期定額等多樣的投資方式與工具，找到適合的商品。';
                    this.adType = 'smartChoiceBanner';
                });
            } else if (this.$route.name === 'purchase_search') {
                window.FRSToolV3.getConfig({ page: 'purchase', type: 'smartChoiceBanner' }).then((res: any) => {
                    this.purchaselist = res.result;
                    this.title = '基金搜尋與品牌';
                    this.content = '請根據下方選項說明，選擇挑選商品的方式';
                    this.adType = 'fundSearchBanner';
                });
            }
        }
    }
});
